import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateUserRequirementsApi = createApi({
  reducerPath: 'policyTemplateUserRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getUserRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/user-requirements/preview`,
        params: { customerId },
      }),
    }),
    resolveUserRequirementNames: builder.mutation({
      query: ({ customerId, userIds }) => ({
        url: '/secure/policy/template/user-requirements/resolve',
        method: 'POST',
        body: { customerId, userIds },
      }),
    }),
  }),
})

export const {
  useGetUserRequirementsPreviewQuery,
  useLazyGetUserRequirementsPreviewQuery,
  useResolveUserRequirementNamesMutation,
} = policyTemplateUserRequirementsApi

export const useUserRequirementsPreview = ({ templateId, customerId: customerIdOverride }, options = {}) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  // Deploy from a check can target a different tenant than the globally selected customer.
  // Callers pass that tenant; otherwise fall back to the global selection.
  const customerId = customerIdOverride ?? selectedCustomerId

  return useGetUserRequirementsPreviewQuery(
    { templateId, customerId },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
